module.exports = __webpack_public_path__ + "static/media/banner.2bd6d184.png";